import React, { useState, useRef, useEffect } from 'react';
import { IconTag, IconUser } from '@tabler/icons-react';
import { EcClickUpFilterChip } from '../../experiencia-cliente/components/EcClickUpFilterChip';
import { BoardSearchSimplePickerPanel } from '../../board/board-search-filters/BoardSearchSimplePickerPanel';

function HubFilterPickerDropdown({ open, className = '', children }) {
  if (!open) return null;
  return (
    <div
      className={[
        'board-search-filters-popover',
        'board-search-filters-popover--simple',
        'hub-sugestoes-filter-dropdown',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}

export default function HubRoadmapFilters({
  categories = [],
  filterCategoryIds = null,
  onFilterCategoryToggle,
  onFilterSelectNone,
  onFilterSelectAll,
  onlyMySuggestions = false,
  onOnlyMySuggestionsChange,
}) {
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const categoryDropdownRef = useRef(null);

  useEffect(() => {
    const onOutside = (e) => {
      if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(e.target)) {
        setCategoryDropdownOpen(false);
      }
    };
    if (categoryDropdownOpen) document.addEventListener('click', onOutside);
    return () => document.removeEventListener('click', onOutside);
  }, [categoryDropdownOpen]);

  const catList = categories || [];
  const allSelected = filterCategoryIds == null;

  const currentCategoryLabel = (() => {
    if (allSelected) return 'Todas as categorias';
    if (!filterCategoryIds?.length) return 'Nenhuma categoria';
    if (filterCategoryIds.length === 1) {
      return catList.find((c) => c.id === filterCategoryIds[0])?.name || '1 categoria';
    }
    return `${filterCategoryIds.length} categorias`;
  })();

  const isCategorySelected = (categoryId) =>
    filterCategoryIds == null || filterCategoryIds.includes(categoryId);

  const handleBulkToggleAll = () => {
    if (allSelected) {
      onFilterSelectNone?.();
    } else {
      onFilterSelectAll?.();
    }
  };

  return (
    <div className="hub-feedback-toolbar-filters" role="group" aria-label="Filtros do roadmap">
      <div ref={categoryDropdownRef} className="hub-sugestoes-filter-anchor">
        <EcClickUpFilterChip
          label="Categoria"
          value={currentCategoryLabel}
          icon={IconTag}
          hasSelection={!allSelected}
          isOpen={categoryDropdownOpen}
          ariaLabel="Filtrar por categoria"
          className="hub-sugestoes-filter-chip"
          onClick={() => setCategoryDropdownOpen((v) => !v)}
        />
        <HubFilterPickerDropdown open={categoryDropdownOpen} className="hub-sugestoes-filter-dropdown--category">
          <BoardSearchSimplePickerPanel
            showSearch={false}
            items={catList}
            getKey={(c) => c.id}
            getLabel={(c) => c.name || 'Geral'}
            isSelected={(c) => isCategorySelected(c.id)}
            onToggle={(c) => onFilterCategoryToggle?.(c.id)}
            listAriaLabel="Filtrar por categoria"
            bulkMenuEnabled={catList.length > 0}
            onBulkToggleAll={handleBulkToggleAll}
          />
        </HubFilterPickerDropdown>
      </div>

      <EcClickUpFilterChip
        label="Minhas sugestões"
        icon={IconUser}
        hasSelection={!!onlyMySuggestions}
        showValue={false}
        ariaLabel="Somente minhas sugestões"
        className="hub-sugestoes-filter-chip"
        tooltip="Ao marcar, visualiza somente meus feedbacks"
        tooltipMultiline
        onClick={() => onOnlyMySuggestionsChange?.(!onlyMySuggestions)}
      />
    </div>
  );
}
